import { useAuthStore } from '../stores/authStore';
import { CAPABILITY_MAP } from '../constants/roles';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const company = useAuthStore((s) => s.company);
  const role = useAuthStore((s) => s.role);
  const effectivePermissions = useAuthStore((s) => s.effectivePermissions);
  const setAuth = useAuthStore((s) => s.setAuth);
  const setEffectivePermissions = useAuthStore((s) => s.setEffectivePermissions);
  const clearAuth = useAuthStore((s) => s.clearAuth);
  const isSuperAdmin = useAuthStore((s) => s.isSuperAdmin);
  const isIcAdmin = useAuthStore((s) => s.isIcAdmin);
  const hasPermission = useAuthStore((s) => s.hasPermission);

  const isAuthenticated = !!token && !!user;

  /**
   * Checks if the current user can perform an action.
   * First checks effectivePermissions from the backend (fine-grained strings).
   * Falls back to CAPABILITY_MAP role checks for legacy capability keys.
   */
  const can = (action: string): boolean => {
    if (!role) return false;
    // Super-admin / ic-admin bypass all checks
    if (role === 'super-admin' || role === 'admin' || role === 'ic-admin') return true;
    // Check fine-grained effective permissions if available
    if (effectivePermissions.length > 0) {
      if (effectivePermissions.includes('*')) return true;
      if (effectivePermissions.includes(action)) return true;
    }
    // Fall back to legacy CAPABILITY_MAP
    return (CAPABILITY_MAP[action] ?? []).includes(role);
  };

  return {
    user,
    token,
    company,
    role,
    effectivePermissions,
    isAuthenticated,
    setAuth,
    setEffectivePermissions,
    clearAuth,
    isSuperAdmin,
    isIcAdmin,
    hasPermission,
    can,
  };
}
